import { MutableRefObject, useCallback, useRef,  } from 'react';

const useIntersectionObserver = (observerCallBack: () => void, observerOptions?:any, dependencyArrayOptions ?: any[] ) => {
  let intersectionObserverRef  :  MutableRefObject<IntersectionObserver | null>  = useRef()
  return useCallback((node : Element | null) => {
    if (!node) return;

    if( intersectionObserverRef.current) intersectionObserverRef.current.disconnect()

    intersectionObserverRef.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observerCallBack();
      }
    }, observerOptions);

    intersectionObserverRef?.current?.observe(node);

    return () => {
      intersectionObserverRef?.current?.disconnect();
    };

  }, dependencyArrayOptions);
};

export default useIntersectionObserver;
